import React from "react";
import { IconButton } from "@chakra-ui/core";
import { FaPlus } from "react-icons/fa";
import NewPaymentLink from "../forms/NewPaymentLink";

/** The + (plus) button on the dashboard header to openup the form
 * to create a new payment link
 */

const AddMenu = () => {
  const [isCreateLink, setIsCreateLink] = React.useState(false);

  return (
    <>
      <IconButton
        variant="ghost"
        color="primary.100"
        aria-label="Mobile menu icon"
        size="xs"
        fontSize="20px"
        _hover={{
          bg: "none",
          color: "primary.300",
        }}
        icon={FaPlus}
        onClick={() => setIsCreateLink(true)}
      />
      <NewPaymentLink {...{ isCreateLink, setIsCreateLink }} />
    </>
  );
};

export default AddMenu;
